import React from "react";
import Button from "@shared/v2/Button";
import TextButton from "@shared/v2/TextButton";
import { ArrowUpRightFromSquareSolidV6 } from "@shared/v2/Icomoon";
import ZoomCard from "./shared/ZoomCard";

const BrivityLeadsCard = () => (
  <ZoomCard
    actions={
      <>
        <Button
          size="medium"
          schema="secondary"
          className="tw-flex tw-items-center tw-gap-[4px]"
          onClick={() => {}}
        >
          Get More Leads <ArrowUpRightFromSquareSolidV6 />
        </Button>
        <TextButton className="tw-px-0 tw-flex tw-items-center tw-gap-[4px]" size="medium">
          Learn More <ArrowUpRightFromSquareSolidV6 />
        </TextButton>
      </>
    }
    title="Brivity Leads"
    description="Make it easier to connect with your leads, gain insight into your marketing campaigns, and understand your ROI like never before."
    imgSrc="/images/bg-card-brivity-leads.png"
    imgClassName="tw-mr-[-12px]"
  />
);

export default BrivityLeadsCard;
